// @flow
import styled from 'styled-components';
import 'react-progress-button/react-progress-button.css';
import ProgressButton, { STATE } from 'react-progress-button';

export const PROGRESS_STATE = STATE;

export default styled(ProgressButton)`
  width: auto !important;
  transition: 0.3s ease;
  .pb-button {
    background-color: ${props => props.theme.colors.green} !important;
    padding: 10px !important;
    height: 40px !important;
    border-radius: 20px !important;
    width: 150px !important;
    font-size: 16px !important;
    color: white !important;
    border: none !important;
    box-shadow: 0px 5px 20px 1px rgba(0, 214, 178, 0.2) !important;
    transition: 0.3s ease !important;
    cursor: pointer !important;
    font-family: ${props => props.theme.fontBold};
    > span {
      font-size: 16px !important;
      font-weight: 400 !important;
    }
    > svg {
      height: 20px !important;
      width: 20px !important;
    }
    &:focus {
      outline: none;
    }
    &:active,
    &:disabled {
      background-color: ${props => props.theme.colors.lightGrey} !important;
      box-shadow: 0px 5px 20px 1px rgba(0, 0, 0, 0) !important;
    }
  }
  &.loading .pb-button {
    background-color: ${props => props.theme.colors.lightGrey} !important;
    box-shadow: 0px 5px 20px 1px rgba(0, 0, 0, 0) !important;
  }
  &.error {
    .pb-button {
      background-color: ${props => props.theme.colors.red} !important;
    }
  }
  &.success,
  &.error {
    transform: scale(1.1);
    svg {
      height: 40px !important;
      width: 40px !important;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/button/progress.js